export default "__VITE_ASSET__DyZfILvr__"